<div class="relation-info-header">
  <div class="text-heading">
    Selecteer hieronder de klantenkaart waarmee je verder wilt gaan.
  </div>
</div>
<div class="relation-container grid-desktop-9 grid-tablet-9 grid-mobile-1">
  @for (relation of relations; track relation) {
    <div class="relation {{relation.is_business ? 'business' : 'consumer'}}"
      [attr.tabindex]="0"
      [class.selected]="relation === selectedRelation"
      (click)="selectedRelation = relation"
      (keydown.enter)="selectedRelation = relation"
      [attr.aria-label]="relation.full_name"
      >
      <div class="selector">
        <app-icon [icon]="(relation === selectedRelation) ? 'circle-dot' :  'circle'"></app-icon>
      </div>
      <div class="address-info grid-4 --force text-subtitle">
        <div class="col-span-4 text-heading">{{ relation.full_name }}</div>
        <div class="col-span-4">{{ relation.customer_id }} | {{relation.is_business ? 'Zakelijk' : 'Particulier'}}</div>
        <div class="col-span-4">{{ relation.street }} {{ relation.housenumber }}{{ relation.housenumberext }}</div>
        <div class="col-span-4">{{ relation.zipcode }} {{ relation.city }}</div>
      </div>
    </div>
  }
</div>
<div class="action-container">
  <app-button
    (keydown.enter)="submit()"
    (click)="submit()"
    [block]="true">
    Bevestigen
  </app-button>
</div>

<a class="btn-logout" [attr.tabindex]="0" (click)="logout()" (keydown.enter)="logout()">
  <app-icon icon="arrow-right-from-bracket" class="float-right"></app-icon>
  <span class="hide-mobile float-right">Uitloggen</span>
</a>
